/**
 * Hook: DELETE /api/t/{slug}/sample-data
 *
 * Design reference: ``backend/docs/batch_19_design.md`` §8, §9.5.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";

interface SampleDataDeleteResult {
  rows_affected: { candidates: number; jds: number };
}

export function useDeleteSampleData() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  const queryClient = useQueryClient();

  return useMutation<SampleDataDeleteResult, Error>({
    mutationFn: async () => {
      const r = await apiClient.delete<SampleDataDeleteResult>(
        `/api/t/${tenantSlug}/sample-data`
      );
      return r.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["candidates", tenantSlug] });
      void queryClient.invalidateQueries({ queryKey: ["jds", tenantSlug] });
    },
  });
}
